









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Location as RouteLocation } from 'vue-router';
import ExtLink from '@/components/ext/Link.vue';
import { JustWrapper } from '@/components/markup';

@Component({
  components: {
    ExtLink,
    JustWrapper,
  },
})
export default class ComponentPartCatalogListCardLink extends Vue {
  @Prop({ type: [Boolean, String], default: false })
  target: false | string;

  @Prop({ type: Boolean, default: false })
  isWrap: false;

  @Prop({ type: [String, Object], required: true })
  to: string | RouteLocation;

  get bindings() {
    const { $router, target, tag, to } = this;
    return tag === 'a'
      ? {
          target: target || '_self',
          href: $router.resolve(to).href,
        }
      : { to };
  }

  get tag() {
    const { target } = this;
    return !target || target === '_self' ? 'ExtLink' : 'a';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/list/item/components/Link.vue